import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kiosk.camera');
import { OnInit, Input } from "@angular/core";
import { ElementRef, ViewChild } from "@angular/core";
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-kiosk-camera',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kiosk.camera/view.scss */
.video-container {
  width: 1080px;
  height: 835px;
  overflow: hidden;
  position: relative;
}

video {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scaleX(-1);
  object-fit: cover;
}`],
})
export class PortalKioskCameraComponent implements OnInit {
    @ViewChild('video') video: ElementRef;
    @ViewChild('canvas') canvas: ElementRef;
    @ViewChild('capturedImage') capturedImage: ElementRef;

    @Input() event: any;
    @Input() opts: any;

    public imageCapture: any;
    public status: any = 'ready';
    public countdown: any = 0;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();

        const video = this.video.nativeElement;
        navigator.mediaDevices.getUserMedia({ video: true })
            .then(async (stream) => {
                video.srcObject = stream;
                const track = stream.getVideoTracks()[0];
                this.imageCapture = new ImageCapture(track);
                await this.imageCapture.takePhoto();
            }).catch(err => { });
    }

    public async take() {
        this.status = 'capture';
        this.countdown = 0;
        await this.service.render();

        for (let i = 0; i < 5; i++) {
            await this.service.render(1000);
            this.countdown = this.countdown + 1;
        }

        let blob = await this.imageCapture.takePhoto();

        this.status = 'captured';
        await this.service.render();

        blob = await this.cropImageToRatio(blob, 1080, 835);
        this.blob = blob;

        const url = URL.createObjectURL(blob);
        this.capturedImage.nativeElement.src = url;

        this.countdown = 0;
        await this.service.render();
    }
    public async create() {
        await this.event.set("image", this.blob);
        await this.event.view("create");
    }

    public async restart() {
        const video = this.video.nativeElement;
        navigator.mediaDevices.getUserMedia({ video: true })
            .then(async (stream) => {
                video.srcObject = stream;
                const track = stream.getVideoTracks()[0];
                this.imageCapture = new ImageCapture(track);
                await this.imageCapture.takePhoto();
            }).catch(err => { });
        this.imageCapture = null;
        await this.service.render();
        await this.take();
    }

    public cropImageToRatio(blob: Blob, targetWidth: number, targetHeight: number): Promise<Blob> {
        return new Promise((resolve, reject) => {
            const img = new Image();
            const targetRatio = targetWidth / targetHeight;

            img.onload = () => {
                const originalWidth = img.width;
                const originalHeight = img.height;
                const originalRatio = originalWidth / originalHeight;

                let cropWidth, cropHeight, offsetX, offsetY;

                if (originalRatio > targetRatio) {
                    cropHeight = originalHeight;
                    cropWidth = cropHeight * targetRatio;
                    offsetX = (originalWidth - cropWidth) / 2;
                    offsetY = 0;
                } else {
                    // 원본이 더 높은 경우
                    cropWidth = originalWidth;
                    cropHeight = cropWidth / targetRatio;
                    offsetX = 0;
                    offsetY = (originalHeight - cropHeight) / 2;
                }

                const canvas = document.createElement('canvas');
                canvas.width = cropWidth;
                canvas.height = cropHeight;
                const ctx = canvas.getContext('2d');

                ctx.translate(canvas.width, 0);
                ctx.scale(-1, 1);

                ctx.drawImage(
                    img,
                    offsetX, offsetY, cropWidth, cropHeight,
                    0, 0, cropWidth, cropHeight
                );

                canvas.toBlob((croppedBlob) => {
                    if (croppedBlob) {
                        resolve(croppedBlob);
                    } else {
                        reject(new Error('Crop failed'));
                    }
                }, 'image/jpeg');
            };

            img.onerror = (err) => {
                reject(err);
            };

            img.src = URL.createObjectURL(blob);
        });
    }

}

export default PortalKioskCameraComponent;